import {
  PersonInvolvementKindSchema,
  type PersonInvolvementKind,
  type ViewRoute,
} from "../types/involvement.js";

/**
 * The involvement kinds the acting user holds themselves among `routes`, once
 * each and in the order `PersonInvolvementKindSchema` lists them. Empty where
 * they reach the person only through their organisation.
 */
export const involvementKindsHeldByUser = (
  routes: readonly ViewRoute[],
): PersonInvolvementKind[] =>
  PersonInvolvementKindSchema.options.filter((kind) =>
    routes.some((route) => route.heldBy === "user" && route.kind === kind),
  );
